import { render, staticRenderFns } from "./ButtonBadgeRenderer.vue?vue&type=template&id=6def6942&"
import script from "./ButtonBadgeRenderer.vue?vue&type=script&lang=ts&"
export * from "./ButtonBadgeRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports